(function($) {
    var __selCounty = '[id^="county-"]',
        __selVoivodeship = 'g[id^="voivodeship-"]',
        __selSpecialization = '.features-list--specialization [data-category]',
        __selContainer = '[data-container="consultant"]',
        __selTemplate = '[data-template="consultant"]',
        __selAvatar = '.consultant__avatar',
        __selName = '.consultant__name',
        __selEmail = '.consultant__email',
        __selPhoneStart = '.consultant__phone .phone-start',
        __selPhoneEnd = '.consultant__phone .phone-button',
        __selQrCode = '.qr img',
        __clsSpecializationSelected = 'active',
        __clsMapObjectSelected = 'selected',
        __clsObjectDisabled = 'disabled',
        __clsMapZoomed = 'zoomed',
        __regexPhoneStart = /(\s|\-){1}[\s\S]+/g,
        __regexPhoneEnd = /([\S]{3}[\s]{0,1}){1}/g,
        __zoomFactor = 3,
        __searchParams = {},
        buttonZoomOut = $('.button-zoomout'),
        $map,
        fnInit = function() {
            return fnBootstrapMapObject(this),
                   fnRegisterTriggers(this),
                   fnBootstrapSelf(this);
        },
        fnBootstrapMapObject = function($context) {
            $map = $context;

            $map.isZoomed = false;
            $map.zoomFactor = __zoomFactor;
            $map.SVG = $context.get(0);
            $map.plane = {
                height: $map.SVG.getBBox().height,
                width: $map.SVG.getBBox().width,
                centerX: $map.SVG.getBBox().width / 2,
                centerY: $map.SVG.getBBox().height / 2,
                displayScale: $map.width() / $map.SVG.getBBox().width
            };
            $map.selectedCounty = null;
            $map.selectedVoivodeship = null;
            $map.selectedSpecialization = null;

            $map.zoomOut = objFnZoomOut;
            $map.zoomIn = objFnZoomIn;
            $map.hasFullData = objFnHasFullData;
            $map.getAjaxData = objFnGetAjaxData;
            $map.currentCounty = objFnCurrentCounty;
            $map.currentVoivodeship = objFnCurrentVoivodeship;
            $map.scaleTransform = objFnScaleTransform,
            $map.scaleTransformOut = objFnScaleTransformOut;

            $map.find(__selVoivodeship).each(utilFnCalcVoivodeshipData);
        },
        fnRegisterTriggers = function($context) {
            $(__selSpecialization).on('click specialization:update', handleSpecializationUpdate);

            buttonZoomOut.on('click', function() {
                $map.zoomOut()
            });

            $context.on('click voivodeship:update', __selVoivodeship, handleVoivodeshipUpdate)
                    .on('click county:update', __selCounty, handleCountyUpdate);
        },
        fnBootstrapSelf = function() {
            return utilFnStripQuery(),
                   utilFnSelectSpecialization()
        },
        fnSearch = function() {
            return utilFnAjax(
                        window.CMS.routes.consultant_search,
                        $map.getAjaxData(),
                        fnApplySearchResult
                    );
        },
        fnApplySearchResult = function(response) {
            if( response.length === 0 )
            {
                return handleAjaxEmptyResponse(response);
            }

            var $container = $(__selContainer),
                content = null;

            $.each(response, function(k, item) {
                var $template = $( $(__selTemplate).html() ),
                    phoneStart = item.phone.replace(__regexPhoneStart, ''),
                    phoneEnd = item.phone.replace(__regexPhoneEnd, '');

                if( phoneStart.length > 3 )
                {
                    phoneStart = item.phone.substr(0, 3);
                    phoneEnd = item.phone.substr(3);
                }

                typeof item.avatar !== 'undefined' && item.avatar !== null && item.avatar.length > 0
                    ? $template.find( __selAvatar ).css('background-image', 'url(' + item.avatar + ')')
                    : null;

                typeof item.qrcode !== 'undefined' && item.qrcode !== null && item.qrcode.length > 0
                    ? $template.find( __selQrCode ).attr('src', item.qrcode)
                    : $template.find( __selQrCode ).addClass('d-none');

                $template.find( __selName ).text(item.name);
                $template.find( __selEmail ).attr('href', 'mailto:' + item.email).find('span').text(item.email);
                $template.find( __selPhoneStart ).text(phoneStart);
                $template.find( __selPhoneEnd ).attr('data-number', phoneEnd)
                    .attr('data-voivodeship', item.voivodeship)
                    .attr('data-county', item.county);

                content = content === null
                        ? $template.get(0).outerHTML
                        : content + $template.get(0).outerHTML;
            });

            $container.animate({opacity:0}, 200, function() {
                $container.html( content ).promise().done(function() {
                    $container.animate({opacity:1}, 300);
                });
            });
        },
        handleSpecializationUpdate = function(event, params) {
            var $this = $(this),
                $new = null,
                newSpecialization = $this.data('category'),
                directive = utilFnExtractDirectives(this, ['skipLevels', 'replaceDefault']);

            let top = $('#localization').offset().top + 140;

            $('html,body').animate({
                scrollTop: top
            }, 750);

            if( $this.hasClass( __clsObjectDisabled ) || $map.selectedSpecialization === newSpecialization )
            {
                return;
            }

            $new = $('[data-category="' + newSpecialization + '"]');

            $('[data-category="' + $map.selectedSpecialization + '"]').removeClass( __clsSpecializationSelected )
                    .promise()
                    .done(function() {
                        $map.selectedSpecialization = newSpecialization;
                        $new.addClass( __clsSpecializationSelected );

                        if( directive )
                        {
                            return utilFnFireDirective(directive);
                        }

                        return utilFnLockObjects(true),
                               ($map.hasFullData()
                                    ? fnSearch()
                                    : ( $map.selectedCounty !== null ? null : $map.zoomOut() )
                                )
                    });
        },
        handleVoivodeshipUpdate = function(event, params) {
            if( $(this).hasClass( __clsObjectDisabled ) )
            {
                return;
            }
            
            return $map.isZoomed ? $map.zoomOut(this) : $map.zoomIn(this);
        },
        handleCountyUpdate = function(event, params) {
            if( $(this).hasClass( __clsObjectDisabled ) || $map.selectedCounty === this.id )
            {
                return;
            }

            return $map.find( '#' + $map.selectedCounty ).removeClass( __clsMapObjectSelected ),
                   $map.selectedCounty = this.id,
                   $(this).addClass( __clsMapObjectSelected ),
                   ( $map.hasFullData() ? fnSearch() : utilFnLockObjects() );
        },
        handleAjaxEmptyResponse = function(response) {
            try {
                var specParams = $map.selectedSpecialization === null ? [] : $('[data-category="' + $map.selectedSpecialization + '"]').data('js-params'),
                    default_response = typeof specParams.defaults === 'object'
                                            ? specParams.defaults
                                            : window.CMS.pageParams.default_consultants;

                return fnApplySearchResult( default_response );
            } catch(e) {}

            $(__selContainer).animate({opacity:0}, 500, function() {
                $(this).html( $(__selTemplate).html() ).promise().done(function() {
                    $(this).animate({opacity:1}, 500);
                });
            });
        },
        handleAjaxError = function(response) {
            return handleAjaxEmptyResponse(response);
        },
        objFnHasFullData = function() {
            return this.selectedSpecialization !== null
                    && this.selectedVoivodeship !== null
                    && this.selectedCounty !== null;
        },
        objFnGetAjaxData = function() {
            return {
                specialization: this.selectedSpecialization,
                voivodeship: this.selectedVoivodeship.replace(/[^\d]+/g, ''),
                county: this.selectedCounty.replace(/[^\d]+/g, '')
            };
        },
        objFnZoomIn = function(context) {
            if( ! this.isZoomed )
            {
                buttonZoomOut.fadeIn();
                let contextId = context.id,
                    check = contextId.indexOf("-slaskie"),
                    zoom = (check != -1) ? context.zoomFactor*1.2 : context.zoomFactor;

                return this.scaleTransform(context.scaledCenterX, context.scaledCenterY, context.translateX, context.translateY, zoom),
                       this.addClass( __clsMapZoomed ),
                       this.isZoomed = true,
                       this.selectedVoivodeship = context.id,
                       this.currentVoivodeship().addClass( __clsMapObjectSelected ),
                       utilFnLockObjects();
            }
        },
        objFnZoomOut = function(context, forceScan = false) {
            buttonZoomOut.fadeOut();

            return this.scaleTransformOut(),
                   this.currentVoivodeship().removeClass( __clsMapObjectSelected ),
                   this.currentCounty().removeClass(__clsMapObjectSelected),
                   this.selectedVoivodeship = null,
                   this.selectedCounty = null,
                   this.removeClass( __clsMapZoomed ),
                   this.isZoomed = false,
                   utilFnLockObjects(forceScan);
        },
        objFnCurrentVoivodeship = function() {
            return this.selectedVoivodeship === null
                    ? $(null)
                    : this.find('g[id="' + this.selectedVoivodeship.replace('voivodeship', 'v').replace(/-[\d]+/g, '') + '"]');
        },
        objFnCurrentCounty = function() {
            return this.selectedCounty === null
                    ? $(null)
                    : this.find('#' + this.selectedCounty);
        },
        objFnScaleTransform = function(centerX, centerY, translateX, translateY, zoomFactor) {
            return this.SVG.style.transformOrigin = (centerX/this.plane.width)*100 + '% ' + (centerY/this.plane.height)*100 + '%',
                   this.SVG.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + zoomFactor + ')';
        },
        objFnScaleTransformOut = function() {
            return this.SVG.style.transform = 'translate(0,0) scale(1)';
        },
        utilFnStripQuery = function (callback) {
            if( window.location.search.length )
            {
                var searchString = window.location.search.replace(/^\?/, '');

                $.each(searchString.split('&'), function() {
                    var split = this.split('='),
                        name = split.shift(0,1);

                    if( typeof __searchParams[name] !== 'undefined' && __searchParams[name] !== null)
                    {
                        __searchParams[name] = typeof __searchParams[name] === 'string'
                                                    ? [ __searchParams[name] ].concat( split )
                                                    : __searchParams[name].concat( split )
                    }
                    else
                    {
                        __searchParams[name] = split;
                    }
                });
            }

            if( typeof callback === 'function' )
            {
                callback();
            }
        },
        utilFnSelectSpecialization = function() {
            var specializations = typeof __searchParams.specialization === 'undefined' || __searchParams.specialization === null
                                    ? null
                                    : __searchParams.specialization;

            if( specializations === null )
            {
                return utilFnLockObjects();
            }

            $.proxy(handleSpecializationUpdate, $( __selSpecialization.replace(']', '="' + specializations + '"]') ).get(0) )();
        },
        utilFnLockObjects = function(forceScan = false) {
            if( $map.hasFullData() && ! forceScan )
            {
                return;
            }
            else if( $map.selectedSpecialization === null || $map.selectedVoivodeship === null )
            {
                return  handleAjaxEmptyResponse(),
                        utilFnAjax(
                            window.CMS.routes.empty_voivodeships,
                            { specialization: $map.selectedSpecialization },
                            utilFnToggleVoivodeshipsLock
                        );
            }
            else
            {
                utilFnAjax(
                    window.CMS.routes.empty_counties,
                    {
                        specialization: $map.selectedSpecialization,
                        voivodeship: $map.selectedVoivodeship.replace(/[^\d]+/g, '')
                    },
                    utilFnToggleCountiesLock
                );
            }
        },
        utilFnToggleVoivodeshipsLock = function(response) {
            $(__selVoivodeship).each(function() {
                (response.indexOf( parseInt( this.id.replace(/[^\d]+/g, '') ) ) === -1)
                    ? $(this).removeClass(__clsObjectDisabled)
                    : $(this).addClass(__clsObjectDisabled);
            });
        },
        utilFnToggleCountiesLock = function(response) {
            var selector = $map.selectedVoivodeship !== null && $map.selectedVoivodeship.length > 0
                                ? 'g[id="' + $map.selectedVoivodeship.replace('voivodeship', 'v').replace(/-[\d]+/g, '') + '"]'
                                : 'g[id^="voivodeship-"]'

            $map.find( selector )
                .find(__selCounty).each(function() {
                    response.indexOf( parseInt( this.id.replace(/[^\d]+/g, '') ) ) === -1
                        ? $(this).removeClass(__clsObjectDisabled)
                        : $(this).addClass(__clsObjectDisabled);

                    if(this.id === $map.selectedCounty && $map.currentCounty().hasClass(__clsObjectDisabled) )
                    {
                        $map.zoomOut();
                        return false;
                    }
                });
        },
        utilFnAjax = function(url, data, callback) {
            $.ajax({
                method: 'post',
                url: url,
                data: data,
                success: callback,
                error: handleAjaxError
            });
        },
        utilFnCalcVoivodeshipData = function() {
            this.width = this.getBBox().width;
            this.height = this.getBBox().height;
            this.offsetX = this.getBBox().x;
            this.offsetY = this.getBBox().y;
            this.centerX = this.offsetX + this.width / 2;
            this.centerY = this.offsetY + this.height / 2;
            this.scaledCenterX = this.centerX * $map.plane.displayScale;
            this.scaledCenterY = this.centerY * $map.plane.displayScale;
            this.translateX = ($map.plane.centerX - this.centerX) * $map.plane.displayScale;
            this.translateY = ($map.plane.centerY - this.centerY) * $map.plane.displayScale;

            var maxZoomX = $map.plane.width / this.width,
                maxZoomY = $map.plane.height / this.height,
                zoomX = maxZoomX <= $map.zoomFactor ? maxZoomX : $map.zoomFactor,
                zoomY = maxZoomY <= $map.zoomFactor ? maxZoomY : $map.zoomFactor;

            this.zoomFactor = zoomX <= zoomY ? zoomX : zoomY;
        },
        utilFnExtractDirectives = function(object, allowed) {
            try {
                if( typeof object.dataset.jsParams !== 'string' || object.dataset.jsParams.length === 0 )
                {
                    return false;
                }

                var directive = JSON.parse(object.dataset.jsParams);

                return allowed.indexOf(directive.directive) !== -1
                        ? directive
                        : false;

            } catch(e) {
                console.log(e);
                return false;
            }

        },
        utilFnFireDirective = function({directive, data}) {
            if( directive === 'skipLevels' )
            {
                if( $map.isZoomed )
                {
                    $map.scaleTransformOut();
                    $map.currentVoivodeship().removeClass( __clsMapObjectSelected );
                    $map.currentCounty().removeClass(__clsMapObjectSelected);
                    $map.isZoomed = false;
                    $map.selectedVoivodeship = null;
                    $map.selectedCounty = null;
                    $map.removeClass(__clsMapZoomed);
                }
                return utilFnLockObjects(), fnApplySearchResult(Array.isArray(data) ? data : [data]);
            }
        };

    $.fn.consultantMap = function() {
        $.proxy(fnInit, this)();

        return this;
    };
})(jQuery);